import React, { useEffect, useState } from 'react'

import {fetchSinglePage} from '../../api'

function SinglePage({id}) {

    const [page, setPage] = useState();

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        
        async function getPage() {
            setIsLoading(true)
            const data = await fetchSinglePage(id);
            if (data) {
                setPage(data);
            }
            setIsLoading(false)
        }
        getPage()

    }, [id])

    return (
        <div>
            {isLoading && <p>Laster</p>}
            <h2>{page?.title?.rendered}</h2>
            <div dangerouslySetInnerHTML={{__html: page?.content?.rendered}} />
        </div>
    )
}
export default SinglePage